import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { MdArrowBackIos, MdArrowForwardIos, MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';

const navLinks = [
    { to: "/", label: "Home" },
    { to: "/webTechnology", label: "Web-Technology" },
   
    {
        label: "Fx-Technology", isSubLink: true, subLinks: [
            { label: "Forex CRM", link: "/forex-crm" },
            { label: "Forex Webdesign", link: "/forex-webdesign" },
            { label: "Forex Liquidity", link: "/forex-liquidity" },
            { label: "Prop Firm CRM", link: "/propfirm" },
            { label: "Forex Copier", link: "/forex-copier" },
            { label: "Dedicated Server", link: "/dedicated-server" },
            { label: "Backend Solutions", link: "/backend-solution" },
            { label: "Risk Management", link: "/risk-management" },
            
        ]
    },
    { to: "/regulation", label: "Regulations" },
    { to: "/about", label: "About" },
    { to: "/pricing", label: "Pricing" }
];

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const {pathname}=useLocation()


    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setOpenDropdown(null)
    };

    const toggleDropdown = (label) => {
        setOpenDropdown(openDropdown === label ? null : label);
    };

    return (
        <nav className="bg-gray-900 text-white sticky top-0 z-50 shadow-md font-bold">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">
                    <Link to="/">
                        <img className="h-[50px] w-auto" src="/cLogo.png" alt="Logo" />
                    </Link>
                    <div className="lg:hidden">
                        <button onClick={toggleMenu} className="text-white bg-sky-400 p-3 rounded-lg">
                            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
                        </button>
                    </div>
                    <div className={`lg:flex lg:space-x-6 absolute lg:static left-0 top-full w-full lg:w-auto bg-gray-900 lg:bg-transparent transition-all ${isOpen ? "block" : "hidden"}`}>
                        {navLinks.map((link, index) => (
                            <div key={index} className="relative text-center lg:text-left">
                                {link.isSubLink ? (
                                    <>
                                        <button className=" flex items-center justify-center w-full px-4 py-2 ">
                                            <span className=' hover:text-blue-400'>{link.label}</span>
                                            {
                                                openDropdown === link.label ? <MdKeyboardArrowDown onClick={() => toggleDropdown(link.label)} size={24} className=' mt-1' />
                                                    : <MdArrowForwardIos onClick={() => toggleDropdown(link.label)} size={17} className=' mt-1' />
                                            }
                                        </button>
                                        <div className={`lg:absolute left-0 top-full  flex items-center justify-center shadow-md rounded-md lg:w-48 w-full  transition-all duration-500 ${openDropdown === link.label ? "block" : "hidden"}`}>
                                            <ul className=' bg-white w-1/2 lg:w-48'>
                                                {link.subLinks.map((item) => (
                                                    <li onClick={()=>{
                                                        toggleDropdown(null)
                                                    }}  key={item.link}>
                                                        <Link to={item.link} className="block px-4 py-2 text-black hover:text-blue-600">
                                                            {item.label}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </>
                                ) : (
                                    <Link onClick={()=>{
                                        toggleMenu()
                                        toggleDropdown(null)
                                    }} to={link.to} className={`block px-4 py-2 hover:text-blue-400 ${pathname==link.to? " text-blue-600":" text-white"}`}>
                                        {link.label}
                                    </Link>
                                )}
                            </div>
                        ))}
                        <Link to="/contact" onClick={()=>{
                            toggleDropdown(null)
                        }} className="block text-center lg:text-left mt-2 lg:mt-0">
                            <button className="bg-sky-400 text-white font-bold px-6 py-3 rounded w-full lg:w-auto">
                                Get Started
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
